import { Box } from "@chakra-ui/react";
import { Link as RouterLink, useLocation } from "react-router-dom";

/** Icon-only nav rail item (slim sidebar). `label` doubles as the tooltip/aria-label. */
const MenuItem = ({ label, url = "/", icon, onClick }) => {
    const location = useLocation();
    const isActive = location.pathname === url || location.pathname.startsWith(`${url}/`);

    return (
        <Box
            as={RouterLink}
            to={url}
            onClick={onClick}
            aria-label={label}
            title={label}
            aria-current={isActive ? "page" : undefined}
            display="flex"
            alignItems="center"
            justifyContent="center"
            w="44px"
            h="40px"
            borderRadius="10px"
            color={isActive ? "var(--brand-on-primary, white)" : "#87839A"}
            bg={isActive ? "var(--brand-accent, #a855f7)" : "transparent"}
            transition="background 0.15s ease-in-out, color 0.15s ease-in-out"
            _hover={isActive ? undefined : { bg: "rgba(255,255,255,0.08)", color: "white" }}
        >
            {icon}
        </Box>
    );
};

export default MenuItem;
